import React from "react";
import { useTranslation } from "react-i18next";
import { useRefinementList } from "react-instantsearch-hooks-web";
import { useTheme } from "../context/ThemeContext";

export default function RefinementNoCount({
  attribute,
  searchable = false,
  title,
}) {
  const { theme: t, isForest } = useTheme();
  const { t: tr } = useTranslation();
  const {
    items,
    refine,
    canRefine,
    searchForItems,
  } = useRefinementList({
    attribute,
    operator: "or",
    limit: 100,
    searchable,
    sortBy: ["name:asc"],
  });

  // Theme-based styles
  const wrapperStyle = {
    backgroundColor: isForest ? 'rgba(6,78,59,0.3)' : t.surface.card,
    border: `1px solid ${isForest ? 'rgba(255,255,255,0.1)' : t.surface.cardBorder}`,
  };

  const inputStyle = {
    backgroundColor: isForest ? '#0f3a30' : t.input.background,
    border: `1px solid ${isForest ? 'rgba(255,255,255,0.1)' : t.input.border}`,
    color: isForest ? '#e8f5e9' : t.text.primary,
  };

  return (
    <div className="rounded-xl p-3" style={wrapperStyle}>
      {title && (
        <h4 className="text-xs font-medium mb-2" style={{ color: isForest ? '#a5d6a7' : t.text.secondary }}>{title}</h4>
      )}

      {searchable && (
        <input
          type="text"
          placeholder={`${tr('common.search')} ${title?.toLowerCase() || tr('home.searchPlaceholder')}…`}
          onChange={(e) => searchForItems(e.currentTarget.value)}
          className="w-full mb-2 px-2 py-1 rounded-md focus:outline-none"
          style={inputStyle}
        />
      )}

      {!canRefine ? (
        <div className="text-sm" style={{ color: isForest ? '#a5d6a7' : t.text.tertiary }}>No options</div>
      ) : (
        <ul className="max-h-64 overflow-auto space-y-1">
          {items.map((item) => (
            <li key={item.label}>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={item.isRefined}
                  onChange={() => refine(item.value)}
                  className="accent-green-600"
                />
                {/* No count rendered */}
                <span className="text-sm" style={{ color: isForest ? '#e8f5e9' : t.text.primary }}>{item.label}</span>
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
